import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

import { Prerequisite } from '../../../../types/courseMaintainerTypes';
import { CourseFormMode } from '../types';

export const useColumnsPrerequisites = ({
  mode,
  onDeletePrerequisite,
  readOnly = false,
}: {
  mode: CourseFormMode;
  onDeletePrerequisite: (index: number) => void;
  readOnly?: boolean;
}) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);

  const columns: ColumnTable<Prerequisite>[] = useMemo(() => {
    const isDisabled = readOnly || mode === CourseFormMode.WATCH;
    return [
      {
        columnName: 'shortening',
        width: '30%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteShortening`),
      },
      {
        columnName: 'name',
        width: '40%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteName`),
      },
      {
        columnName: 'credits',
        width: '15%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteCredits`),
      },
      {
        columnName: 'id',
        width: '15%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteDelete`),
        cellFormat: ({ index }) => (
          <div
            className={!isDisabled ? 'cursor-pointer' : ''}
            onClick={() => {
              if (!isDisabled) onDeletePrerequisite(index);
            }}
          >
            <Icon
              size="15"
              name="trash"
              color={isDisabled ? 'disabled' : 'primary'}
            />
          </div>
        ),
      },
    ];
  }, [t, onDeletePrerequisite, mode, readOnly]);

  return { columns };
};
